<template>
    <div class="legend">
        图例：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <template v-for="phase in phaseConf">
            <div class="bar" :class="phase.cssClass"></div>
            {{phase.text}}
        </template>
    </div>
</template>

<script>
    // last modified by koqiui
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    //
    export default {
        name: 'swb-task-symb',
        desc: '任务图例',
        props: {
            taskPhaseConf: {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data() {
            return {
                phaseConf: []
            };
        },
        watch: {
            taskPhaseConf(newVal, oldVal) {
                this.doInit();
            }

        },
        created() {
            this.doInit();
        },
        methods: {
            doInit() {
                this.phaseConf = this.taskPhaseConf;
            }
        }
    }
</script>


<style>
    .legend {
        display: inline-block;
        padding: 10px;
        border: 1px dotted #CCCCCC;
        border-radius: 2px;
    }

    .legend .bar {
        border: 1px solid #008000;
        border-radius: 2px;
        height: 10px;
        width: 50px;
        display: inline-block;
        margin-left: 10px;
    }

</style>



// WEBPACK FOOTER //
// src/compo/task/TaskSymb.vue